import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from "@angular/router";
import {filter} from "rxjs";

export interface Breadcrumb {
  label: string;
  link: string;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css'
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Array<{ label: string, url: string }> = [];

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.breadcrumbs = this.createBreadcrumbs();
    });

    // Initial breadcrumbs setup
    this.breadcrumbs = this.createBreadcrumbs();
  }

  createBreadcrumbs(): Array<{ label: string, url: string }> {
    const urlSegments = this.router.url.split('/').filter(segment => segment);
    let breadcrumbs = [];
    let accumulatedUrl = '';

    for (const segment of urlSegments) {
      // Skip specific segments
      if (['en', 'de', 'admin'].includes(segment.toLowerCase())) {
        accumulatedUrl += `/${segment}`;
        continue;
      }

      accumulatedUrl += `/${segment}`;
      breadcrumbs.push({
        label: this.capitalizeFirstLetter(segment),
        url: accumulatedUrl
      });
    }

    return breadcrumbs;
  }

  isAuthRoute(): boolean {
    const url = this.router.url.toLowerCase();
    return url.includes('login') || url.includes('register') || url.includes('password-reset') || url.includes('password-forgot');
  }

  capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
